import React, { useState, useEffect } from 'react';
import { getDatosFeeLogisticoSellersApi, updateFeeLogisticosActivoProximo } from "../../../../api/axios";
import { toast } from '../../../../utilities/appToast';
import BigSpinner from "../../../General/BigSpinner";
import { toastApiErrors } from "../../../../utilities/apiErrors";

export default function TablaFeeLogistico({ titulo }) {
    const parametro = titulo === "Fee Anterior" ? 0 : titulo === "Fee Activo" ? 1 : 2;
    const [isLoading, setIsLoading] = useState(true);
    const [feeLogisticos, setFeeLogisticos] = useState([]);// Estado para feeLogistico
    const [vigenteDesde, setVigenteDesde] = useState(""); //  Estado para la fechafesde
    const [vigenteHasta, setVigenteHasta] = useState(""); //  Estado para la fecha hasta

    const [columnasVisibles, setColumnasVisibles] = useState([]);

    const esSoloLectura = titulo === "Fee Anterior";

    useEffect(() => {
        setIsLoading(true);

        getDatosFeeLogisticoSellersApi(parametro)
            .then(res => {
                const datos = res.data.datosFeeLogisticoSellers || [];
                //Extrae las fechas y las formatea para mostraslas correctamente en el input
                if (datos.length > 0) {
                    setVigenteDesde(datos[0]?.vigenteDesde.split("T")[0] || "");
                    setVigenteHasta(datos[0]?.vigenteHasta.split("T")[0] || "");
                }

                const datosTransformados = transformarDatos(datos);
                setFeeLogisticos(datosTransformados);
            })
            .catch(err => {
                toastApiErrors(err, toast, { level: "warn" });
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [parametro]);

    //useEffect optimizado: Calcula columnas visibles cuando cambia feeLogisticos
    useEffect(() => {
        if (feeLogisticos.length > 0) {
            // Calcula y actualiza las columnas visibles según los datos de feeLogisticos
            setColumnasVisibles(obtenerColumnas(feeLogisticos));
        }
    }, [feeLogisticos]);



    const obtenerColumnas = (datos) => {
        //Set se usa en lugar de un array porque no permite valores duplicados.
        const columnas = new Set();
        datos.forEach(item => {
           if (!item.costos) {
                console.warn("El item no tiene costos definidos:", item);
            } else {
                if (item.costos.amba) {
                    columnas.add("amba");
                }
                if (item.costos.interior) {
                    columnas.add("interior");
                }
                if (item.costos.patagonia) {
                    columnas.add("patagonia");
                }
            }
        });

        //Convierte el set en Array y lo devuelve
        const columnasArray = Array.from(columnas);
        return columnasArray;
    };



    const transformarDatos = (datos) => {
        const resultado = [];

        datos.forEach(item => {
            // Buscar si ya existe un grupo con la misma descripción
            let escalaExistente = resultado.find(r => r.descripcion === item.descripcion);

            if (!escalaExistente) {
                escalaExistente = {
                    idEscala: item.idEscala,
                    descripcion: item.descripcion,
                    costos: {
                        amba: {},
                        interior: {},
                        patagonia: {}
                    }
                };
                resultado.push(escalaExistente);
            }

            // Asignamos los valores según la zona
            if (item.amba) {
                escalaExistente.costos.amba = {
                    idCostoFee: item.idCostoFee,
                    costo: item.amba.costo || "",
                    diasEntrega: item.amba.diasEntrega || ""
                };
            }

            if (item.interior) {
                escalaExistente.costos.interior = {
                    idCostoFee: item.idCostoFee,
                    costo: item.interior.costo || "",
                    diasEntrega: item.interior.diasEntrega || ""
                };
            }

            if (item.patagonia) {
                escalaExistente.costos.patagonia = {
                    idCostoFee: item.idCostoFee,
                    costo: item.patagonia.costo || "",
                    diasEntrega: item.patagonia.diasEntrega || ""
                };
            }
        });
        return resultado;
    };




    const onSubmit = () => {
        // Construir la estructura del objeto con los costos editados
        const costosFeeEditados = feeLogisticos.flatMap(fee =>
            ["amba", "interior", "patagonia"].flatMap(zona => {
                const costo = parseFloat(fee.costos[zona].costo) || 0;
                const diaEntrega = parseInt(fee.costos[zona].diasEntrega) || 0;
                const idFeeLogistico = fee.costos[zona].idCostoFee; // 🔹 Corregido: Accede correctamente al ID

                // Validar que tenga datos válidos antes de agregarlo
                if (idFeeLogistico && (costo > 0 || diaEntrega > 0)) {
                    return {
                        idFeeLogistico, // 🔹 Ahora obtiene el ID correcto
                        costo,
                        // diaEntrega,
                        // envioGratis: costo === 0 // Si el costo es 0, asumimos que es envío gratis
                    };
                }
                return [];
            })
        );

        // Construir el objeto final con las fechas del input
        const requestData = {
            costosFeeEditados,
            vigenteDesde: vigenteDesde ? new Date(vigenteDesde).toISOString() : null,
            vigenteHasta: vigenteHasta ? new Date(vigenteHasta).toISOString() : null
        };

        updateFeeLogisticosActivoProximo(requestData)
            .then((res) => {
                if(res.data?.mensaje){
                    toast.success(res.data.mensaje);
                }else{
                    toast.success("Fee Logístico actualizado correctamente");
                }
                
            })
            .catch(err => {
                const errores = err?.response?.data?.errores;
                if (Array.isArray(errores))
                    errores.forEach(error => toast.error(error.item2));
                else
                    toast.error("El Fee no pudo ser actualizado");
            });
    };


    const handleFechaDesdeChange = (e) => {
        const nuevaFechaDesde = e.target.value;
        setVigenteDesde(nuevaFechaDesde);
        if (vigenteHasta && nuevaFechaDesde > vigenteHasta) {
            setVigenteHasta(nuevaFechaDesde);
        }
    };

    const handleChange = (e, idEscala, zona, campo) => {
        const { value } = e.target;

        setFeeLogisticos((prevState) =>
            prevState.map((fee) =>
                fee.idEscala === idEscala // Encuentra la escala correspondiente
                    ? {
                        ...fee, // Copia todo el objeto actual
                        costos: {
                            ...fee.costos, // Copia todas las zonas existentes
                            [zona]: {
                                ...fee.costos[zona], // Copia los datos de la zona específica
                                [campo]: value, // Actualiza el campo modificado (costo o diasEntrega)
                            },
                        },
                    }
                    : fee // Mantiene los otros elementos sin cambios
            )
        );

    };


    return (
        <div>
            <div className="col-12 col-md-auto align-self-center">
                <h4 className="text-themecolor color-rojo-megatone">{titulo}</h4>
    
                {isLoading ? (
                    <BigSpinner message="Cargando tabla de fee logistico..." />
                ) : feeLogisticos.length === 0 ? (
                    <h5 className="d-flex justify-content-center m-t-40 m-b-40">
                        NO SE ENCONTRARON RESULTADOS
                    </h5>
                ) : (
                    <>
                        {/* 🔹 Fechas alineadas horizontalmente */}
                        <div className="d-flex justify-content-start align-items-center gap-3 mt-2 mb-3">
                            <div>
                                <strong className="text-muted">Fecha desde</strong>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={vigenteDesde}
                                    min={new Date().toISOString().split("T")[0]}
                                    onChange={handleFechaDesdeChange}
                                    disabled={esSoloLectura}
                                />
                            </div>
                            <div>
                                <strong className="text-muted">Fecha hasta</strong>
                                <input
                                    type="date"
                                    className="form-control"
                                    min={vigenteDesde}
                                    value={vigenteHasta}
                                    onChange={(e) => setVigenteHasta(e.target.value)}
                                    disabled={esSoloLectura}
                                />
                            </div>
                        </div>
    
                        <div className={`card ${esSoloLectura ? "bg-gray" : ""}`} style={{ maxHeight: "600px" }}>
                            <div className="table-responsive" style={{ overflowY: "auto" }}>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th><small>Descripción</small></th>
                                            {columnasVisibles.map((zona) => (
                                                <React.Fragment key={zona}>
                                                    <th><small>Costo {zona.toUpperCase()}</small></th>
                                                    <th><small>Días Entrega {zona.toUpperCase()}</small></th>
                                                </React.Fragment>
                                            ))}
                                        </tr>
                                    </thead>
    
                                    <tbody>
                                        {feeLogisticos.map((fee, index) => (
                                            <tr key={index}>
                                                <td><small>{fee.descripcion}</small></td>
                                                {columnasVisibles.map((zona) => (
                                                    <React.Fragment key={zona}>
                                                        <td>
                                                            <div className="d-flex align-items-center">
                                                                <small className="me-2">$</small>
                                                                <input
                                                                    type="number"
                                                                    value={fee.costos[zona]?.costo || ""}
                                                                    min="0"
                                                                    className="form-control text-center"
                                                                    disabled={esSoloLectura}
                                                                    onChange={(e) => handleChange(e, fee.idEscala, zona, "costo")}
                                                                />
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                value={fee.costos[zona]?.diasEntrega || ""}
                                                                min="0"
                                                                className="form-control text-center"
                                                                disabled={esSoloLectura}
                                                                onChange={(e) => handleChange(e, fee.idEscala, zona, "diasEntrega")}
                                                            />
                                                        </td>
                                                    </React.Fragment>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
    
                            {/* 🔹 Botón centrado y oculto si no hay datos */}
                            {titulo !== "Fee Anterior" && feeLogisticos.length > 0 && (
                                <div className="d-flex justify-content-center my-3">
                                    <button
                                        onClick={onSubmit}
                                        className="btn btn-sm gestion-liquidaciones-btn-guardar"
                                    >
                                        Actualizar Fee
                                    </button>
                                </div>
                            )}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
    
}